module.exports = __webpack_public_path__ + "media/images/front/academy-99fc7e0cbd5b3f2e90913419813026de.png";